<template>
  <v-container
    id="world-treasures-list"
    tag="section"
  >
    <!-- Bouton de retour vers la liste des mondes -->
    <v-row>
      <v-btn
        text
        @click="routeToWorldsList()"
      >
        <v-icon left>
          mdi-chevron-left
        </v-icon>
        Retour
      </v-btn>
    </v-row>

    <!-- Toast de réussite ou d'échec -->
    <!--<v-snackbar
      v-model="msg.alert"
      top
      shaped
      :color="msg.type"
      :timeout="msg.timeout"
    >
      <v-icon left>
        {{ msg.icon }}
      </v-icon>
      {{ msg.msg }}

      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="msg.alert = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>-->
    <v-row justify="center">
      <v-col cols="8">
        <timed-alert
          :display="msg.alert"
          :msg="msg.msg"
          :type="msg.type"
        />
      </v-col>
    </v-row>

    <base-material-card
      color="primary"
      icon="mdi-briefcase-variant"
      inline
      class="px-5 py-3"
    >
      <template v-slot:heading>
        <div class="display-2 font-weight-light">
          <v-icon left>
            mdi-book-open-page-variant
          </v-icon>
          {{ title }}
        </div>
      </template>

      <!-- **************** ***
      ****      MODALS      ***
      **** **************** -->
      <!-- Modal de création de trésor -->
      <template v-slot:after-heading>
        <v-dialog
          v-model="addDialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              outlined
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>
                mdi-plus
              </v-icon>
              Ajouter un trésor
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline secondary--text">Nouveau trésor</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <!-- Formulaire -->
                <v-form
                  ref="addForm"
                  v-model="addIsValid"
                >
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="addedItem.text"
                        :rules="[rules.required]"
                        label="Text..."
                        prepend-icon="mdi-book-open-page-variant"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="addedItem.type"
                        :items="types"
                        label="Type..."
                        prepend-icon="mdi-video-vintage"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="addedItem.source"
                        auto-grow
                        label="source..."
                        rows="2"
                        counter="255"
                        prepend-icon="mdi-clipboard-text-multiple"
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-model="addedItem.position"
                        type="number"
                        :rules="[rules.required]"
                        min="1"
                        step="1"
                        label="Position..."
                        prepend-icon="mdi-order-numeric-ascending"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="success darken-1"
                text
                :disabled="!addIsValid"
                @click="addItem()"
              >
                Créer
              </v-btn>
              <v-btn
                color="error darken-1"
                text
                @click="addDialog = false"
              >
                Annuler
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <!-- Modal de modification de trésor -->
      <v-dialog
        v-model="editDialog"
        persistent
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            <span class="headline secondary--text">Modification du trésor<br><b>{{ editedItem.title }}</b></span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <!-- Formulaire -->
              <v-form
                ref="editForm"
                v-model="editIsValid"
              >
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.text"
                      :rules="[rules.required]"
                      label="Texte..."
                      prepend-icon="mdi-book-open-page-variant"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="editedItem.type"
                      :items="types"
                      label="Type..."
                      prepend-icon="mdi-video-vintage"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="editedItem.source"
                      auto-grow
                      label="source..."
                      rows="2"
                      counter="255"
                      prepend-icon="mdi-clipboard-text-multiple"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.position"
                      type="number"
                      :rules="[rules.required]"
                      min="1"
                      step="1"
                      label="Position..."
                      prepend-icon="mdi-order-numeric-ascending"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="success darken-1"
              text
              :disabled="!editIsValid"
              @click="editItem()"
            >
              Modifier
            </v-btn>
            <v-btn
              color="error darken-1"
              text
              @click="editDialog = false"
            >
              Annuler
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal de suppression de trésor -->
      <v-dialog
        v-model="deleteDialog"
        persistent
        max-width="500px"
      >
        <v-card>
          <v-card-title class="headline">
            Êtes-vous sûr de vouloir<br>supprimer Le trésor
            <div class="container">
              <span class="secondary--text">
                <b>{{ deletedItem.title }}</b>
              </span>
              ?
            </div>
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="success darken-1"
              text
              @click="deleteItem()"
            >
              Supprimer
            </v-btn>
            <v-btn
              color="error darken-1"
              text
              @click="deleteDialog = false"
            >
              Annuler
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- **************** ***
      ****      TABLE      ***
      **** **************** -->
      <!-- Champ de recherche dans la table -->
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Rechercher"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :sort-by="['id']"
        :sort-desc="[false]"
        :loading="isLoading"
        multi-sort
      >
        <!-- Définition du lien avec l'url -->
        <template v-slot:item.url="{ item }">
          <a
            :href="item.url"
            target="_blank"
          >
            {{ item.url }}
          </a>
        </template>

        <!-- Définition de l'action d'édition -->
        <template v-slot:item.edit="{ item }">
          <v-row justify="center">
            <v-icon
              class="success--text"
              @click="prepareEditItem(item)"
            >
              mdi-pencil
            </v-icon>
          </v-row>
        </template>

        <!-- Définition de l'action de suppression -->
        <template v-slot:item.delete="{ item }">
          <v-row justify="center">
            <v-icon
              class="error--text"
              @click="prepareDeleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import TimedAlert from '../alerts/TimedAlert.vue'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'WorldTreasuresList',

    /* Sous-composants utilisés par ce composant */
    components: {
      TimedAlert,
    },

    /* Paramètres */
    props: {
      idWorld: {
        type: String,
        default: undefined,
      },
      nameWorld: {
        type: String,
        default: undefined,
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: () => ({
      isLoading: true,

      // Variables pour les formulaires de création / modification / suppression
      rules: {
        required: value => !!value || 'Ce champ ne peut être vide.',
      },

      types: [
        {
          value: 0,
          text: 'Citation',
        },
        {
          value: 1,
          text: 'Vidéo',
        },
      ],
      addDialog: false,
      addIsValid: true,
      addedItem: {
        type: undefined,
        text: undefined,
        source: undefined,
      },

      editDialog: false,
      editIsValid: true,
      editedItem: {
        id: undefined,
        worldId: undefined,
        type: undefined,
        text: undefined,
        source: undefined,
      },

      deleteDialog: false,
      deletedItem: {
        id: undefined,
      },

      // Message de réussite ou d'échec des actions
      msg: {
        alert: false,
        msg: '',
        timeout: 5000,
        type: 'success',
      },

      // Variables relatives au tableau de données
      headers: [
        {
          text: '#',
          value: 'id',
        },
        {
          text: 'Text',
          value: 'text',
        },
        {
          text: 'Type',
          value: 'typeclair',
        },
        {
          text: 'Source',
          value: 'source',
        },
        {
          text: 'Position',
          value: 'position',
        },
        {
          text: 'Nb Like',
          value: 'nbLike',
        },
        {
          text: 'Nb Share',
          value: 'nbShare',
        },
        {
          sortable: false,
          text: 'Éditer',
          value: 'edit',
        },
        {
          sortable: false,
          text: 'Supprimer',
          value: 'delete',
        },
      ],
      items: [],
      search: undefined,
    }),

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      title: function () {
        return 'Trésors ' +
          (this.isVowelIndex(this.nameWorld[0]) ? 'd\'' : 'de ') +
          this.nameWorld
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchTreasures(this.idWorld)
    },

    /* Fonctions internes */
    methods: {
      // State if the char is a vowel
      isVowelIndex: function (char) {
        const vowelsIndex = 'aeiouyAEIOUY'
        if (char.length === 1) {
          return vowelsIndex.indexOf(char) >= 0
        }
      },

      // Récupération des données de toutes les trésors du monde
      fetchTreasures: function (idWorld) {
        if (!this.idWorld) {
          this.items = []
          return
        }
        this.$Auth.httpRequest(
          'get',
          'api/treasure/selectAllByWorld?worldId=' + idWorld,
        )
          .then(datas => {
            if (Array.isArray(datas.data) || datas.data.length > 0) {
              this.items = datas.data
            } else {
              this.items = []
            }
          })
          .catch((/* error */) => {
            this.setMsgError('Une erreur est survenue lors de la récupération de la liste des trésors.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      },

      // Route vers la page de la liste des mondes
      routeToWorldsList: function () {
        this.$router.push({ name: 'Worlds List' })
      },

      /* ********************************* **
      /** Fonctions relatives aux messages **
      /** ******************************** */
      /* Setter de message de réussite */
      setMsgSuccess: function (msg) {
        this.msg.msg = msg
        this.msg.alert = true
        this.msg.type = 'success'
        this.msg.icon = 'mdi-checkbox-marked-circle-outline'
      },

      /* Setter de message d'échec */
      setMsgError: function (msg) {
        this.msg.msg = msg
        this.msg.alert = true
        this.msg.type = 'error'
        this.msg.icon = 'mdi-error-outline'
      },

      /* ******************************* **
      /** Fonctions d'ajout de trésor **
      /** ****************************** */
      addItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.addDialog = false
        this.msg.alert = false

        // Ajout d'une trésor
        this.$Auth.httpRequest('post', 'api/treasure/insert', {
          worldId: this.idWorld,
          type: this.addedItem.type,
          title: this.addedItem.title,
          text: this.addedItem.text,
          source: this.addedItem.source,
          position: this.addedItem.position,
        })
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('Le trésor a été ajouté avec succès.')

            // Réinitialisation des valeurs pour l'item ajouté
            this.addedItem.type = undefined
            this.addedItem.source = undefined
            this.addedItem.text = undefined
            this.addedItem.position = undefined
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Une erreur est survenue lors de l\'ajout du trésor.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.$refs.addForm.resetValidation()
            this.isLoading = false
            this.fetchTreasures(this.idWorld)
          })
      },

      /* *************************************** **
      /** Fonctions de modification de trésor **
      /** ************************************** */
      prepareEditItem: function (item, tab) {
        // Création du clone d'item
        this.editedItem = { ...item }
        this.editDialog = true
      },

      resetEditedItem: function () {
        return {
          id: undefined,
          worldId: undefined,
          type: undefined,
          title: undefined,
          source: undefined,
          position: undefined,
        }
      },

      editItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.editDialog = false
        this.msg.alert = false

        // Modification du trésor
        this.$Auth.httpRequest('post', 'api/treasure/update', {
          treasureId: this.editedItem.id,
          text: this.editedItem.text,
          type: this.editedItem.type,
          source: this.editedItem.source,
          position: this.editedItem.position,
        })
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('Le trésor a été modifié avec succès.')
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Une erreur est survenue lors de la modification du trésor.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.$refs.editForm.reset()
            this.editedItem = this.resetEditedItem()
            this.isLoading = false
            this.fetchTreasures(this.idWorld)
          })
      },

      /* ************************************** **
      /** Fonctions de suppression de trésor **
      /** ************************************* */
      prepareDeleteItem: function (item) {
        // Création du clone d'item
        this.deletedItem = { ...item }
        this.deleteDialog = true
      },

      deleteItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.deleteDialog = false
        this.msg.alert = false

        //  Suppression du trésor
        this.$Auth.httpRequest(
          'delete',
          'api/treasure/delete?id=' + this.deletedItem.id,
        )
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('Le trésor a été supprimé avec succès.')
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Une erreur est survenue lors de la suppression du trésor.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.isLoading = false
            this.fetchTreasures(this.idWorld)
          })
      },
    },
  }
</script>
